<template>
  <div class="save-date-description">
    <div class="save-date-description-area">
      <h1 class="save-date-description-text">SAVE THE DATE</h1>
      <HeaderWidget
        class="save-date-description-names"
        :font="textFont"
        header-separator="&"
        :main-color="mainColor"
        :her-name="herName"
        :his-name="hisName"
      ></HeaderWidget>
      <p class="save-date-description-date">{{ date }}</p>
      <a
        v-if="placeText && placeLink"
        :href="placeLink"
        class="save-date-description-date"
        >{{ placeText }}</a
      >
      <img
        class="save-date-description-img"
        src="@/assets/main/logo.png"
        alt=""
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useStateStore } from '@/stores/state.store';
import { useSaveDateStore } from '@/stores/saveDate/saveDate.store';
import HeaderWidget from '../common/HeaderWidget.vue';

const stateStore = useStateStore();
const saveDateStore = useSaveDateStore();

const backgroundColor = toRef(() => stateStore.getColors.backgroundColor);
const mainColor = toRef(() => stateStore.getColors.mainColor);

const herName = saveDateStore.getCommonData.herName;
const hisName = saveDateStore.getCommonData.hisName;
const textFont = saveDateStore.getCommonData.textFont;
const placeLink = saveDateStore.getCommonData.place;
const date = toRef(() => saveDateStore.getLangAllLangData().date);
const placeText = toRef(() => saveDateStore.getLangAllLangData().place);
</script>

<style scoped lang="scss">
.save-date {
  &-description {
    color: v-bind(mainColor);
    display: flex;
    width: 100%;
    height: 50%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 5% 0;
    font-size: 16px;
    margin-top: 60vh;
    z-index: 10;

    &::before {
      content: '';
      position: absolute;
      inset: 55vh 0 0;
      backdrop-filter: blur(20px);
      mask: linear-gradient(transparent, black 15%);
      transition: 1s;
      opacity: 1;
      z-index: 0;
    }

    &-area {
      color: v-bind(mainColor);
      display: flex;
      width: 100%;
      height: 100%;
      padding: 15px;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      gap: 30px;
      background: linear-gradient(
          90deg,
          rgb(255 0 0 / 0%) 0%,
          v-bind(backgroundColor) 50%,
          rgb(255 0 0 / 0%) 100%
        ),
        linear-gradient(
          180deg,
          rgb(255 0 0 / 0%) 0%,
          v-bind(backgroundColor) 50%,
          rgb(255 0 0 / 0%) 100%
        );

      @media (max-width: $media-max-phone) {
        gap: 25px;
        width: 90%;
      }
    }

    &-text {
      font-size: 4em;
      line-height: 1em;
      text-align: center;
      z-index: 1;
      font-family: 'MADE Mirage', serif;
      font-weight: 700;

      @media (max-width: $media-max-phone) {
        font-size: 2em;
        font-weight: 700;
      }
    }

    &-names {
      font-size: 11px;
      text-align: center;
      z-index: 1;
    }

    &-date {
      font-size: 2.5em;
      line-height: 1em;
      text-align: center;
      z-index: 1;
      font-family: 'MADE Mirage', serif;

      @media (max-width: $media-max-phone) {
        font-size: 1.75em;
      }
    }

    &-img {
      max-width: 200px;
      z-index: 1;
    }
  }
}
</style>
